import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const MinimizeIcon = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_6189_2342)" strokeLinejoin="round" fill="currentColor"><path d="M7.50006 1C7.50006 0.723858 7.2762 0.5 7.00006 0.5C6.72392 0.5 6.50006 0.723858 6.50006 1L7.50006 1ZM7.00006 5H6.50006V5.5H7.00006V5ZM11.0001 5.5C11.2762 5.5 11.5001 5.27614 11.5001 5C11.5001 4.72386 11.2762 4.5 11.0001 4.5V5.5ZM11.8536 0.853553C12.0489 0.658291 12.0489 0.341709 11.8536 0.146447C11.6584 -0.0488155 11.3418 -0.0488155 11.1465 0.146447L11.8536 0.853553ZM0.146447 11.1464C-0.0488155 11.3417 -0.0488155 11.6583 0.146447 11.8536C0.341709 12.0488 0.658291 12.0488 0.853553 11.8536L0.146447 11.1464ZM5 7H5.5C5.5 6.86739 5.44732 6.74021 5.35355 6.64644C5.25978 6.55268 5.13261 6.5 5 6.5V7ZM4.5 11C4.5 11.2761 4.72386 11.5 5 11.5C5.27614 11.5 5.5 11.2761 5.5 11L4.5 11ZM0.999999 6.5C0.723857 6.5 0.499999 6.72386 0.499999 7C0.5 7.27614 0.723857 7.5 1 7.5L0.999999 6.5ZM6.50006 1L6.50006 5H7.50006L7.50006 1L6.50006 1ZM7.00006 5.5L11.0001 5.5V4.5L7.00006 4.5V5.5ZM7.35361 5.35355L11.8536 0.853553L11.1465 0.146447L6.64651 4.64645L7.35361 5.35355ZM0.853553 11.8536L5.35355 7.35355L4.64645 6.64644L0.146447 11.1464L0.853553 11.8536ZM5.5 11L5.5 7H4.5L4.5 11L5.5 11ZM5 6.5L0.999999 6.5L1 7.5L5 7.5V6.5Z" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_6189_2342"><path d="M0 0H12V12H0z" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default MinimizeIcon;